<p-autocomplete 
    (keydown.enter)="onEnter($event)"
    (onBlur)="onBlur($event)"
    [minLength]="1"
    [delay]="500"
    [(ngModel)]="values"
    [ngModelOptions]="{standalone: true}"
    [unique]="true"
    [typeahead]="typeahead()"
    [suggestions]="filteredSuggestions()"
    (completeMethod)="search($event)" 
    (onSelect)="onSelect($event)"
    autocomplete 
    multiple 
    fluid />

<!-- Fade-out error message -->
<div *ngIf="invalidEmailMessage()"
     class="text-red-500 text-sm mt-1 transition-opacity duration-1000"
     [ngClass]="{ 'opacity-100': !isFadingOut(), 'opacity-0': isFadingOut() }">
    {{ invalidEmailMessage() }}
</div>
